import actions from "@/store/modules/account-type/actions";
import mutations from "@/store/modules/account-type/mutations";
import state from "@/store/modules/account-type/state";

export default {
    actions,
    mutations,
    state
}